import { render, staticRenderFns } from "./AppUpdateMessage.vue?vue&type=template&id=7272a1f0"
import script from "./AppUpdateMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppUpdateMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports